import SegmentString from './SegmentString.js'
export default class NodableSegmentString {
  addIntersection(intPt, segmentIndex) {}
  get interfaces_() {
    return [SegmentString]
  }
}
